import { render, staticRenderFns } from "./swiperServices.vue?vue&type=template&id=a0d88862&"
import script from "./swiperServices.vue?vue&type=script&lang=js&"
export * from "./swiperServices.vue?vue&type=script&lang=js&"
import style0 from "./swiperServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0d88862')) {
      api.createRecord('a0d88862', component.options)
    } else {
      api.reload('a0d88862', component.options)
    }
    module.hot.accept("./swiperServices.vue?vue&type=template&id=a0d88862&", function () {
      api.rerender('a0d88862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperServices/swiperServices.vue"
export default component.exports